module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Union-74bb1152e4e141e2654a5b33d50d5f67.svg";